module.exports = __webpack_public_path__ + "static/media/discord.6d34de52.svg";